module.exports = __webpack_public_path__ + "static/logo-color-a3102a1adc0aac75ebbeda8b1f85d73a.svg";